import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SidebarMode = 'expanded' | 'collapsed';

interface SidebarState {
  mode: SidebarMode;
  pinned: boolean;
  mobileOpen: boolean;
}

const initialState: SidebarState = {
  mode: 'expanded',
  pinned: true,
  mobileOpen: false,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggle(state) {
      state.mode = state.mode === 'expanded' ? 'collapsed' : 'expanded';
    },
    expand(state) {
      state.mode = 'expanded';
    },
    collapse(state) {
      state.mode = 'collapsed';
    },
    setMode(state, action: PayloadAction<SidebarMode>) {
      state.mode = action.payload;
    },
    togglePinned(state) {
      state.pinned = !state.pinned;
    },
    openMobile(state) {
      state.mobileOpen = true;
    },
    closeMobile(state) {
      state.mobileOpen = false;
    },
    toggleMobile(state) {
      state.mobileOpen = !state.mobileOpen;
    },
  },
});

export const {
  toggle,
  expand,
  collapse,
  setMode,
  togglePinned,
  openMobile,
  closeMobile,
  toggleMobile,
} = sidebarSlice.actions;

export default sidebarSlice.reducer;
